import { render, staticRenderFns } from "./StockTakeSummary.vue?vue&type=template&id=4a43b12d&lang=pug&"
import script from "./StockTakeSummary.vue?vue&type=script&lang=js&"
export * from "./StockTakeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports